import dotenv from 'dotenv';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faAngleRight,
  faAngleDown,
  faInfoCircle,
  faSort,
  faSortDown,
  faSortUp,
  faPaperclip,
  faPlus,
  faSearch,
  faEdit,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueAnalytics from 'vue-analytics';
import Vue from 'vue';
import App from './App.vue';
import NavBar from './components/NavBar.vue';
import router from './router';


dotenv.config();

library.add(
  faAngleRight,
  faAngleDown,
  faInfoCircle,
  faSort,
  faSortDown,
  faSortUp,
  faPaperclip,
  faPlus,
  faSearch,
  faEdit,
);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('nav-bar', NavBar);

Vue.config.productionTip = false;

Vue.use(VueAnalytics, {
  id: 'UA-134157675-1',
  router,
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
